import React from "react";

const PrivacyPolicyContent = () => {
  return (
    <div className="mx-auto max-w-3xl break-words leading-relaxed">
      <div className="space-y-4">
        <div>
          <div className="font-semibold text-xl">Privacy Notice</div>
        </div>
        <div>
          <div>
            <b>Review Date: 12</b>
            <b>th</b>
            <b>&nbsp;June 2025</b>&nbsp;
          </div>
        </div>
        <div>
          <div>
            This Privacy Policy explains how we use the personal information that Qure.ai
            Technologies Private Limited, its subsidiaries and affiliates collects or
            generates both in relation to our Website&nbsp;
            <a href="https://qure.ai/">https://qure.ai/</a>&nbsp;along with any webpages
            and portals thereof and our mobile application, products and services (“
            <b>Privacy Policy</b>”) as updated from time to time.&nbsp;
          </div>
        </div>
        <div>
          <div>
            Qure.ai Technologies Private Limited, company registration CIN
            U74999MH2016PTC283891 having its&nbsp;registered office at Level 7, Commerz
            II, International Business Park, Oberoi Garden City, Off. W.E. Highway,
            Goregaon (E) Mumbai 400063 along with its subsidiaries and affiliates
            (hereafter “<b>Qure</b>”, “<b>we</b>”, “<b>us</b>” or “<b>our</b>”) collects,
            uses or processes your (“<b>you</b>” or “<b>your</b>” or “<b>Customer</b>” or
            “<b>User</b>”) personal data. This Privacy Policy is applicable when you use
            our Website&nbsp;<a href="https://qure.ai/">https://qure.ai/</a>&nbsp;along
            with any webpages and portals thereof or the Qure mobile application i.e.,
            QureApp (the “<b>Website</b>” and “<b>Application</b>” respectively) or Qure’s
            proprietary software including but not limited to qXR, qER, qCT, qScout POqUS,
            qTrack and all its allied renditions, Devices etc. (collectively the “
            <b>Services</b>”). Our Services also include the&nbsp;
            <a href="https://app.qure.ai/">https://app.qure.ai/</a>&nbsp;and&nbsp;
            <a href="https://scan.qure.ai/">https://scan.qure.ai</a>&nbsp;portal, which is
            a platform for free trial of our products.&nbsp;
          </div>
        </div>
        <div>
          <div>
            All definitions in this Privacy Policy shall be interpreted in accordance with
            applicable data protection laws which refers to the General Data Protection
            Regulation (Regulation no. 2016/679) and the Directive on Privacy and
            Electronic Communications (Directive 2002/58/EC), as well as the national
            implementations and related national legislation. All capitalized terms used
            herein and not otherwise defined are defined as set forth in&nbsp;the&nbsp;
            <a href="https://qure.ai/legal/#legal-disclaimer/">Universal Terms</a>
            &nbsp;and&nbsp;
            <a href="https://qure.ai/legal/#legal-disclaimer/:~:text=Universal%20Terms-,Data%20Processing%20Agreement,-Legal%20Disclaimer">
              Data Processing Agreement.
            </a>
            &nbsp;
          </div>
        </div>
        <div>
          <div>
            This Privacy Policy shall be construed in accordance with the applicable data
            protection laws, including but not limited to Data Protection Act 2018,
            General Data Protection Regulation (GDPR), Children’s Online Privacy
            Protection Act (COPPA), Information Technology Act 2000 (IT Act), The
            Information Technology (Reasonable Security Practices and Procedures and
            Sensitive Personal Data or Information) Rules 2011 (SPDI rules) and Health
            Insurance Portability and Accountability Act (HIPAA).
          </div>
        </div>
        <div>
          <div>
            By visiting our Website, or using our Application or Services, you acknowledge
            and accept the data processing described in this Privacy Policy, our Website
            terms and related documents. We will let you know, by posting on our Website
            or otherwise, if we make any changes to this Privacy Policy from time to time.
            Your continued use of the Services after notifying such changes will amount to
            your acknowledgement and acceptance of the amended Privacy Policy.&nbsp;&nbsp;
          </div>
        </div>
        <div>
          <div>
            We strive to treat your personal information as safely and securely as
            reasonably possible. As described below, your personal data may be collected
            and used by Qure or disclosed to third parties for use on behalf of Qure. This
            Privacy Policy describes the information we collect about you and what may
            happen to that information. You must be at least 18 years old to have our
            permission to use our Services. Our policy is that we do not knowingly
            collect, use or disclose Personal data about visitors that are under 18 years
            of age.&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">I. About the service</div>
        </div>
        <div>
          <div>
            See separate ‘Universal Terms’&nbsp;(
            <a href="https://qure.ai/legal/">https://qure.ai/legal/</a>)&nbsp;for
            applicable terms and conditions of the Services that Qure provides.&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">II. Personal data?</div>
        </div>
        <div>
          <div>
            <b>a. What is personal data?</b>&nbsp;
          </div>
        </div>
        <div>
          <div>
            &nbsp;“Personal data” means any information relating to an identified or
            identifiable natural person, known as ‘Data Subject’, who can be identified
            directly or indirectly; it may include name, address, gender, email address,
            phone number, IP address, location data, cookies, call records and similar
            information. It may also include “special categories of personal data” such as
            racial or ethnic origin, political opinions, religious or philosophical
            beliefs, or trade union membership, and the processing of genetic data,
            biometric data for the purpose of uniquely identifying a Data Subject, data
            concerning health or data concerning a natural person’s sexual
            orientation.&nbsp;
          </div>
        </div>
        <div>
          <div>
            <b>b. What Personal data does Qure collect and process?</b>&nbsp;
          </div>
        </div>
        <div>
          <div>
            Qure receives, processes and stores two distinct sets of personal data.  We
            will process the following personal data on the Services:&nbsp;
          </div>
        </div>
        <div>
          <ul className="!list-disc space-y-3">
            <li>User profiles</li>
          </ul>
        </div>
        <div>
          <ul className="!list-disc space-y-3">
            <li>First and Last Name&nbsp;</li>
            <li>E-mail address at the time of sign up&nbsp;</li>
          </ul>
        </div>
        <div>
          <ul className="!list-disc space-y-3">
            <li>Technical usage data</li>
          </ul>
        </div>
        <div>
          <ul className="!list-disc space-y-3">
            <li>
              such as the URL you are accessing the Services from, your IP address, unique
              device ID, network and computer performance, browser type, language and
              identifying information and operating system; &nbsp;
            </li>
            <li>
              information about your use of the Services, such as what you viewed or
              searched for; page response times, download errors, length of visits to
              certain pages, page interaction information (such as scrolling, clicks and
              mouse-overs), consultation length(s), recurrence of visits and other
              interaction information, methods used to browse away from the page.&nbsp;
            </li>
          </ul>
        </div>
        <div>
          <ul className="!list-disc space-y-3">
            <li>
              A third set of personal data is processed using the QureApp, which you as a
              User will upload the data on the platform and Qure will act as Data
              Processor on behalf as of you as Data Controller for this data:
            </li>
          </ul>
        </div>
        <div>
          <ul className="!list-disc space-y-3">
            <li>
              Anonymised patient case information pseudonymized DICOM images including
              embedded metadata;&nbsp;&nbsp;
            </li>
            <li>
              content that you post, upload and/or contribute to the Services;&nbsp;
            </li>
          </ul>
        </div>
        <div>
          <div>
            For the data listed in clause II (b) (3) above, where you as a User of the
            Services will act as Data Controller and Qure&nbsp; as provider of Services,
            will act as a Data Processor, you hereby acknowledge and agree for&nbsp;
            <a href="https://qure.ai/legal/">Data Processing Agreement</a>&nbsp;which is
            effective from the date of your first use of Services. The Data Processing
            Agreement outlines what kind of processing we are instructed to perform on
            your behalf regarding Personal data pertaining to Data Subjects where you are
            the Data Controller.&nbsp;
          </div>
        </div>
        <div>
          <div>
            Information about third parties should only be provided to us if you have
            demonstrable permission and consent of Data Subjects i.e., your patients, to
            do so or if the information is available in the public domain.&nbsp;You shall
            be solely responsible for receiving all informed, written, explicit or
            implicit consents as required under applicable laws, from the Data Subjects
            i.e., your patients or similar data owners. Your use of Services is deemed
            that such consents have been duly received by you and will be available upon
            request for Qure to audit. We will rely on you to provide information which is
            accurate, complete and up to date and you agree to ensure this.&nbsp;&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">
            III. Why does Qure process this Personal data?
          </div>
        </div>
        <div>
          <div>
            Qure will process the Personal data sets described above for the following
            purposes: &nbsp;
          </div>
        </div>
        <div>
          <ul className="!list-disc space-y-3">
            <li>
              To enable you to verify your account, to administer your account, to enable
              and provide the Services and integration with third party services, and to
              provide, personalize and improve your experience with the Services, and to
              otherwise provide the Services according to the Terms of Service; &nbsp;
            </li>
          </ul>
        </div>
        <div>
          <ul className="!list-disc space-y-3">
            <li>
              to send you alerts or messages by email or otherwise, including to provide
              you with marketing of our and our related parties’ products and
              services;&nbsp;
            </li>
            <li>
              to inform you about updates of the Services or the terms and conditions of
              Services;&nbsp;
            </li>
            <li>
              to improve and develop the Services or new services and to analyse your use
              of the Services;&nbsp;
            </li>
            <li>
              to ensure the technical functioning of the Services and to prevent the use
              of the Services in breach of the Terms (including the Universal Terms and
              any other terms in relation to Application or Services);&nbsp;
            </li>
            <li>
              to enforce the Terms and any additional Terms (including the Universal Terms
              and any other terms in relation to Application or Services), including to
              protect our rights, property and safety and the rights, property and safety
              of third parties if necessary; &nbsp;
            </li>
          </ul>
        </div>
        <div>
          <ul className="!list-disc space-y-3">
            <li>
              to fulfil our obligations as Data Controller and Data Processor;&nbsp;
            </li>
            <li>
              to respect and fulfil our obligations in regards to the Rights of the Data
              Subject;&nbsp;
            </li>
            <li>
              to respond to any queries you raise with us and to provide customer support;
              and &nbsp;
            </li>
            <li>to fulfil requirements by law (see clause VIII below). &nbsp;</li>
          </ul>
        </div>
        <div>
          <div>
            We will be unable to provide you the Services unless you provide us with the
            Personal data listed in clause II.b above. The processing of the Personal data
            above is necessary to enter into the Terms (including Universal Terms) with us
            and to maintain the contractual relationship between you and us, where Qure
            will act as Data Processor for the collected data. Some of this collected
            information is subject to processing of third parties, both within and outside
            the European Union (third countries).&nbsp;
          </div>
        </div>
        <div>
          <div>
            The data listed in clause II.b.2 above is solely collected and used for
            performance and issue handling pertaining to the platform and will not be used
            for identifying you as a user, unless this is requested by official legal
            investigations as in provided in clause VIII below.&nbsp;
          </div>
        </div>
        <div>
          <div>
            The processing of your Personal data for the purposes listed above is
            conducted on the basis of the legitimate interest of Qure. Our legitimate
            interest for the processing is maintaining sufficient IT security through
            logging data when you use our Services and to evade fraud and to protect the
            Services from cyber threats. We also log data for the maintenance and
            improvement of our Services.&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">IV. Disclosure of personal data</div>
        </div>
        <div>
          <div>
            There are circumstances where we may wish to disclose or are compelled to
            disclose your Personal data to third parties. These scenarios include
            disclosure to:&nbsp;
          </div>
        </div>
        <div>
          <ul className="!list-disc space-y-3">
            <li>
              our affiliates and sister companies;&nbsp;our service providers who capture
              and store data collected through the forms that are filled by visitors to
              our Website;&nbsp;subject to appropriate legal basis such as consent, our
              advertising and marketing teams who enable us, for example, to deliver
              personalized ads to your devices or who may contact you by email, telephone,
              SMS or by other means;&nbsp;public authorities where we are required by law
              to do so; and&nbsp;other third parties where you have provided your
              consent.&nbsp;
            </li>
            <li>our affiliates and sister companies;&nbsp;</li>
            <li>
              our service providers who capture and store data collected through the forms
              that are filled by visitors to our Website;&nbsp;
            </li>
            <li>
              subject to appropriate legal basis such as consent, our advertising and
              marketing teams who enable us, for example, to deliver personalized ads to
              your devices or who may contact you by email, telephone, SMS or by other
              means;&nbsp;
            </li>
            <li>public authorities where we are required by law to do so; and&nbsp;</li>
            <li>other third parties where you have provided your consent.&nbsp;</li>
          </ul>
        </div>
        <div>
          <div>
            The service providers are contractually bound not to share Personal data
            collected from visitors on our Website with anyone else.&nbsp;
          </div>
        </div>
        <div>
          <div>
            We confirm and acknowledge that we do not commercially exploit or distribute
            Personal data to any third party for commercial purposes. We share and
            disclose your Personal data to companies with which we have contracts in
            place. These companies mainly provide data storage, data analytics,
            advertising, IT support and other services to be able to run and improve our
            Services.&nbsp;&nbsp;
          </div>
        </div>
        <div>
          <div>
            When you use our Services, you may be directed to other websites where the
            Personal data collected is not in our control. The privacy policy of such
            other websites will govern the Personal data obtained from you on that
            website.&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">V. Cookie Statement</div>
        </div>
        <div>
          <div>
            In order to collect the information including Personal data as described in
            this Privacy Policy, we may use cookies and similar technology on our Website.
            A cookie is a small piece of information which is sent to your browser and
            stored on your computer’s hard drive, mobile phone or other device (“
            <b>Cookies</b>”). Cookies can be first party, i.e. cookies that the website
            you are visiting places on your device, or third party cookies, i.e. cookies
            placed on your device through the Website but by third parties, such as,
            Google.&nbsp;&nbsp;
          </div>
        </div>
        <div>
          <div>
            We use the Cookies for the sole purpose of making it possible to browse the
            Website and let you use its functionalities. We use third party Cookies like
            Google Analytics to collect statistical information in an aggregated form on
            the number of users accessing the Website and generate statistical data on how
            the visitor uses the Website. We also use third party advertisements on our
            Website. Some of these advertisers such as Google through Google AdSense
            program may collect information including your IP address, your ISP, the
            browser you used to visit our Website, etc. You can refer to the list of
            cookies used by us along with the purpose of using them below.&nbsp;
          </div>
        </div>
        <div>
          <div>
            You can choose to disable or selectively turn off our third party cookies in
            your browser settings, however, this may affect how you are able to interact
            with our Website as well as other websites.&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold">VI. Our website</div>
        </div>
        <div>
          <div className="table-auto md:hidden">
            <div className="p-4">
              <div className="border border-gray-700">
                <div className="px-3 py-3 font-semibold">
                  <div className="text-sm">
                    <b>Cookie name</b>
                  </div>
                </div>
                <div className="px-3 py-3 font-semibold">
                  <div className="text-sm">
                    <b>Purpose</b>
                  </div>
                </div>
                <div className="px-3 py-3 font-semibold">
                  <div className="text-sm">
                    <b>Duration</b>
                  </div>
                </div>
                <div className="px-3 py-3 font-semibold">
                  <div className="text-sm">
                    <b>Domain</b>
                  </div>
                </div>
                <div className="px-3 py-3 font-semibold">
                  <div className="text-sm">
                    <b>Category</b>
                  </div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">_gat</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    Used by Google Analytics to throttle request rate
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">2 years&nbsp;</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">qure.ai</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">_ga&nbsp;</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.&nbsp;
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Session</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">qure.ai</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">_gid</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.&nbsp;
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Session</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">qure.ai</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">csrftoken&nbsp;</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    Helps prevent Cross-Site Request Forgery (CSRF) attacks.&nbsp;
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">1 year</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">app.qure.ai/scan.qure.ai portal&nbsp;</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">collect</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    Used to send data to Google Analytics about the visitor’s device and
                    behavior. Tracks the visitor across devices and marketing channels.
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Session</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">google-analytics.com&nbsp;</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">_gat</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    Used by Google Analytics to throttle request rate&nbsp;
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">2 years </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">qure.ai&nbsp;</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">_ga</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.&nbsp;
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Session</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">qure.ai&nbsp;</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">_gid</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.{" "}
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Session</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">qure.ai&nbsp;</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </div>
              </div>
            </div>
          </div>
          <table className="hidden table-auto md:block">
            <tbody className="p-4">
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3 font-semibold">
                  <div className="text-sm">
                    <b>Cookie name</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3 font-semibold">
                  <div className="text-sm">
                    <b>Purpose</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3 font-semibold">
                  <div className="text-sm">
                    <b>Duration</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3 font-semibold">
                  <div className="text-sm">
                    <b>Domain</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3 font-semibold">
                  <div className="text-sm">
                    <b>Category</b>
                  </div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">_gat</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    Used by Google Analytics to throttle request rate
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">2 years&nbsp;</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">qure.ai</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">_ga&nbsp;</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.&nbsp;
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Session</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">qure.ai</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">_gid</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.&nbsp;
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Session</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">qure.ai</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">csrftoken&nbsp;</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    Helps prevent Cross-Site Request Forgery (CSRF) attacks.&nbsp;
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">1 year</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">app.qure.ai/scan.qure.ai portal&nbsp;</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">collect</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    Used to send data to Google Analytics about the visitor’s device and
                    behavior. Tracks the visitor across devices and marketing channels.
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Session</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">google-analytics.com&nbsp;</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">_gat</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    Used by Google Analytics to throttle request rate&nbsp;
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">2 years </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">qure.ai&nbsp;</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">_ga</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.&nbsp;
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Session</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">qure.ai&nbsp;</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">_gid</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.{" "}
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Session</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">qure.ai&nbsp;</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <div className="table-auto md:hidden">
            <div className="p-4">
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">AUTH_SESSION_ID</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>Session</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">AUTH_SESSION_ID_LEGACY </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>Session</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">KEYCLOAK_IDENTITY</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>Session</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">KEYCLOAK_IDENTITY_LEGACY</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>Session</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">KEYCLOAK_SESSION</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>10 Days or Session</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">KEYCLOAK_SESSION_LEGACY</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>10 Days or Session</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">csrftoken</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    Helps prevent Cross-Site Request Forgery (CSRF) attacks.&nbsp;
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>1 year</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>platformapi.qure.ai</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">sessionid</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>1 year</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>platformapi.qure.ai</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">_ga_JPCJ0V0E2R</div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.&nbsp;
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>1 year</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>Qure.ai</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </div>
              </div>
              <div className="border border-gray-700">
                <div className="px-3 py-3">
                  <div className="text-sm">
                    mp_290aa5bd816866afa3a 61ec8c43bd26d_mixpanel
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.&nbsp;
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>1 year</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">
                    <b>Qure.ai</b>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </div>
              </div>
            </div>
          </div>
          <table className="hidden table-auto md:block">
            <tbody className="p-4">
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">AUTH_SESSION_ID</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>Session</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">AUTH_SESSION_ID_LEGACY </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>Session</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">KEYCLOAK_IDENTITY</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>Session</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">KEYCLOAK_IDENTITY_LEGACY</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>Session</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">KEYCLOAK_SESSION</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>10 Days or Session</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">KEYCLOAK_SESSION_LEGACY</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>10 Days or Session</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>accounts.qure.ai</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">csrftoken</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    Helps prevent Cross-Site Request Forgery (CSRF) attacks.&nbsp;
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>1 year</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>platformapi.qure.ai</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">sessionid</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Requrired for login</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>1 year</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>platformapi.qure.ai</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Necessary</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">_ga_JPCJ0V0E2R</div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.&nbsp;
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>1 year</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>Qure.ai</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </td>
              </tr>
              <tr className="border border-gray-700">
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    mp_290aa5bd816866afa3a 61ec8c43bd26d_mixpanel
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    Registers a unique ID that is used to generate statistical data on how
                    the visitor uses the Website.&nbsp;
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>1 year</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">
                    <b>Qure.ai</b>
                  </div>
                </td>
                <td className="border border-gray-700 px-3 py-3">
                  <div className="text-sm">Statistics</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <div className="font-semibold text-xl">VII. Your consent</div>
        </div>
        <div>
          <div>
            By contacting us, subscribing to our newsletter, you consent to the processing
            for the purposes contained in&nbsp;clause II(b)&nbsp;above which includes
            processing of your name,&nbsp;gender,&nbsp;contact details and preferences as
            set out in this Privacy Policy. By accepting&nbsp;Qure’s&nbsp;Terms, we
            process your&nbsp;Personal data to be able to fulfil our agreement with you
            for the purposes listed above in&nbsp;clause III.&nbsp;Qure will
            process&nbsp;Personal data if it has a legal obligation to do so to fulfil
            requirements by law as pointed out in&nbsp;clause&nbsp;VIII&nbsp;below’.&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">VIII. Data Subject Rights</div>
        </div>
        <div>
          <div>
            Data Subjects may have numerous rights in relation to their personal
            data.&nbsp;
          </div>
        </div>
        <div>
          <ul className="!list-disc space-y-3">
            <li>
              Right to make a subject access request (SAR): Data Subjects may request in
              writing copies of their personal data. However, compliance with such
              requests is subject to certain limitations and exemptions and the rights of
              other individuals. Each request should make clear that a SAR is being made.
              You may also be required to submit a proof of your identity and any payment
              permitted by law, where applicable.&nbsp;Right to rectification: Data
              Subjects may request that we rectify any inaccurate or incomplete personal
              data.&nbsp;Right to withdraw consent: Data Subjects may at any time withdraw
              their consent to the processing of their personal data carried out by us on
              the basis of their previous consent. Such withdrawal will not affect the
              lawfulness of processing based on such previous consent.&nbsp;Right to
              object to processing including automated processing and profiling: We do not
              make automated decisions about Data Subjects. However, we may rely on
              information provided by third parties such as credit reference agencies
              which may score Data Subjects on the basis of automated decisions. Profiling
              may be carried out for business administration purposes, such as monitoring
              trends in User visits of our Website. We will comply with valid objection
              requests unless we have a compelling overriding legitimate ground for the
              continuation of our processing or we have another lawful reason to refuse
              such request. We will comply with each valid opt-out request in relation to
              marketing communications.&nbsp;Right to erasure: Data Subjects may request
              that we erase their personal data. We will comply, unless there is a lawful
              reason for not doing so. For example, there may be an overriding legitimate
              ground for keeping the personal data, such as, our business record retention
              obligations that we have to comply with.&nbsp;Restriction: Data Subjects may
              request that we restrict our processing of their personal data in various
              circumstances. We will comply, unless there is a lawful reason for not doing
              so, such as, a legal obligation to continue processing your personal data in
              a certain way.&nbsp;Right to data portability: In certain circumstances,
              Data Subjects may request the controller to provide a copy of their personal
              data in a structured, commonly used and machine-readable format and have it
              transferred to another provider of the same or similar services. We do not
              consider that this right applies to our Services. However, to the extent it
              does, we will comply with such transfer request. Please note that a transfer
              to another provider does not imply erasure of the Data Subject’s personal
              data which may still be retained for legitimate and lawful
              purposes.&nbsp;Right to lodge a complaint with the supervisory authority: We
              suggest that Data Subjects contact us about any questions or complaints in
              relation to how we process their personal data. However, each Data Subject
              has the right to contact the relevant supervisory authority directly.&nbsp;
            </li>
            <li>
              Right to make a subject access request (SAR): Data Subjects may request in
              writing copies of their personal data. However, compliance with such
              requests is subject to certain limitations and exemptions and the rights of
              other individuals. Each request should make clear that a SAR is being made.
              You may also be required to submit a proof of your identity and any payment
              permitted by law, where applicable.&nbsp;
            </li>
            <li>
              Right to rectification: Data Subjects may request that we rectify any
              inaccurate or incomplete personal data.&nbsp;
            </li>
            <li>
              Right to withdraw consent: Data Subjects may at any time withdraw their
              consent to the processing of their personal data carried out by us on the
              basis of their previous consent. Such withdrawal will not affect the
              lawfulness of processing based on such previous consent.&nbsp;
            </li>
            <li>
              Right to object to processing including automated processing and profiling:
              We do not make automated decisions about Data Subjects. However, we may rely
              on information provided by third parties such as credit reference agencies
              which may score Data Subjects on the basis of automated decisions. Profiling
              may be carried out for business administration purposes, such as monitoring
              trends in User visits of our Website. We will comply with valid objection
              requests unless we have a compelling overriding legitimate ground for the
              continuation of our processing or we have another lawful reason to refuse
              such request. We will comply with each valid opt-out request in relation to
              marketing communications.&nbsp;
            </li>
            <li>
              Right to erasure: Data Subjects may request that we erase their personal
              data. We will comply, unless there is a lawful reason for not doing so. For
              example, there may be an overriding legitimate ground for keeping the
              personal data, such as, our business record retention obligations that we
              have to comply with.&nbsp;
            </li>
            <li>
              Restriction: Data Subjects may request that we restrict our processing of
              their personal data in various circumstances. We will comply, unless there
              is a lawful reason for not doing so, such as, a legal obligation to continue
              processing your personal data in a certain way.&nbsp;
            </li>
            <li>
              Right to data portability: In certain circumstances, Data Subjects may
              request the controller to provide a copy of their personal data in a
              structured, commonly used and machine-readable format and have it
              transferred to another provider of the same or similar services. We do not
              consider that this right applies to our Services. However, to the extent it
              does, we will comply with such transfer request. Please note that a transfer
              to another provider does not imply erasure of the Data Subject’s personal
              data which may still be retained for legitimate and lawful purposes.&nbsp;
            </li>
            <li>
              Right to lodge a complaint with the supervisory authority: We suggest that
              Data Subjects contact us about any questions or complaints in relation to
              how we process their personal data. However, each Data Subject has the right
              to contact the relevant supervisory authority directly.&nbsp;
            </li>
          </ul>
          <div>
            <span className="font-semibold">
              Additional Data Subject Rights under CCPA/CPRA
            </span>
            <p>
              Right to Opt-Out of Sale or Sharing of Personal Information: Data Subjects
              have the right to direct us not to sell or share their personal information
              with third parties for cross-contextual behavioural advertising purposes.
            </p>
            <p>
              Right to Limit Use and Disclosure of Sensitive Personal Information:
              California residents may request that we limit the use and disclosure of
              Sensitive Personal Information to only what is necessary for delivering
              requested services.
            </p>
            <p>
              Right to Non-Discrimination: Data Subjects have the right not to receive
              discriminatory treatment for exercising any of their privacy rights under
              the CCPA/CPRA.
            </p>
            <p>
              Right to Know: Data Subjects have the right to know what personal
              information is collected, used, shared, or sold by a business, including
              specific categories and purposes.
            </p>
          </div>
          <div>
            <p className="font-semibold">
              Additional Data Subject Rights applicable to Vietnam Data Subjects
            </p>
            <p>
              Right to Self-Defence: The personal data subject has the right to protect
              their personal data by themselves or through a representative in accordance
              with the provisions of this Decree and relevant laws
            </p>
            <p>
              Right to Claim Damages: Data Subjects may claim compensation from data
              controllers/processors in cases of unauthorized processing or data breaches
              that cause harm.
            </p>
          </div>
          <div>
            <p className="font-semibold">
              Additional Rights applicable to Indian Data Principles
            </p>
            <p>
              Right to Nominate: Data Principals may nominate another individual to
              exercise their rights in the event of death or incapacity.
            </p>
            <p>
              Right to Grievance Redressal: Every Data Principal has the right to register
              a grievance with the Data Fiduciary and, if not resolved within the
              stipulated period, escalate it to the Data Protection Board of India.
            </p>
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">IX. Responding to Legal Requests</div>
        </div>
        <div>
          <div>
            We may access,&nbsp;preserve&nbsp;and share your&nbsp;Personal data in
            response to a legal request (like a search warrant, court order or a subpoena
            or the like), or when necessary to detect, prevent and address fraud and other
            illegal activity, to protect ourselves, you and other&nbsp;users, including as
            part of investigations described in Article 23(1) in the GDPR. &nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">X. Retention of Personal Data</div>
        </div>
        <div>
          <div>
            Personal data about registered users will be retained for as long as the user
            has an active profile on the Services. users who have not used our Services
            will have all personal data deleted after 1 year of inactivity on the
            Services.&nbsp;
          </div>
        </div>
        <div>
          <div>
            If you agree to be added to our mailing list, we will keep your personal
            information for that purpose unless and until you tell us that you want to
            unsubscribe or be removed from the list. If you advise that you do not want to
            be added to our mailing list or you ask to be removed, we will delete your
            Personal data (aside from keeping a record that you have asked us not to send
            you marketing information).&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">
            XI. Personal data of children under the age of 18
          </div>
        </div>
        <div>
          <div>
            The QureApp and the Services provided under it are not directed at, marketed
            to, nor intended for, children under 18 years of age. The Website does not
            knowingly collect or solicit information from anyone under the age of 18 or
            allow anyone under the age of 18 to sign up for the Service. In the event that
            you learn that you have gathered personal information from anyone under the
            age of 18 without the consent of a parent or guardian, you will delete that
            information as soon as possible.&nbsp;
          </div>
        </div>
        <div>
          <div>
            You are required under the Children’s Online Privacy Protection Act (“
            <b>COPPA</b>”) as well as the GDPR and other Personal Data Protection laws (as
            those may apply) to obtain verifiable parental consent (or from the child’s
            legal representative) in order to collect, use or disclose Personal Data
            pertaining to that child.&nbsp;
          </div>
        </div>
        <div>
          <div>
            If you are a parent or guardian of a person under the age of 18 and you become
            aware of that the child has provided personal data to us without your consent,
            please contact&nbsp;<a href="mailto:dpo@qure.ai">dpo@qure.ai</a>&nbsp; to
            exercise your access, rectification, erasure, limiting of processing and
            objection rights.&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">XII. International Data Transfer</div>
        </div>
        <div>
          <div>
            Your personal data may be shared with Qure entities globally. Such cross-
            border/third-country data transfers are governed by the provisions of the
            Inter-Group Data Transfer Agreement (IGDTA), ensuring that appropriate
            safeguards are in place to protect user data.&nbsp;&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">XIII. Security Practices</div>
        </div>
        <div>
          <div>
            The importance of security for Personal data is of great concern to us. At
            Qure, we have gone to great lengths to manage the security and integrity of
            the Services and to ensure that we use best–in-class services when providing
            secure transmission of information from your device. Personal Data collected
            via the Services is stored in secure environments that are not available or
            accessible to the public; only those duly authorised people, officers,
            employees or agents of Qure who need access to your information in order to do
            their jobs are allowed access.&nbsp;&nbsp;
          </div>
        </div>
        <div>
          <div>
            Anyone who violates our privacy or security policies is subject to
            disciplinary action, including possible termination of their contract with
            Qure and civil and/or criminal prosecution. Qure uses the latest technologies
            to ensure utmost security, including utilising several layers of firewall
            security and encryption of Personal data to ensure the highest level of
            security. As a result, while we strive to protect your Personal data, you
            acknowledge that:&nbsp;
          </div>
        </div>
        <div>
          <div>
            (a) there are security and privacy limitations of the Internet which are
            beyond our control;&nbsp;
          </div>
        </div>
        <div>
          <div>
            (b) the security, integrity and privacy of any and all information and data
            exchanged between you and us through this Website cannot be guaranteed;
            and&nbsp;
          </div>
        </div>
        <div>
          <div>
            (c) any such information and data may be viewed or tampered with in transit by
            a third party.&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">XIV. Grievance Officer</div>
        </div>
        <div>
          <div>
            To exercise your rights, or if you have any questions&nbsp;or
            complaints&nbsp;regarding our processing of your personal data, please contact
            us our Data Protection Officer (DPO) at the following&nbsp;email ID –&nbsp;
            <a rel="noreferrer" href="mailto:dpo@qure.ai" target="_blank">
              dpo@qure.ai
            </a>
            . In your letter/email please state your full name, your username (if you are
            a user) and which institution you are linked to. Note that you should sign the
            request to receive information about the processing of your personal data
            yourself.&nbsp;
          </div>
        </div>
        <div>
          <div className="font-semibold text-xl">
            XV. Notice of Changes to the Privacy Policy 
          </div>
        </div>
        <div>
          <div>
            If we make changes to this Privacy Policy, we will notify you by posting a
            copy of the updated policy on our Services prior to any change becoming
            effective. We will post a copy of the updated policy on our Services prior to
            any change becoming effective. If your consent is required due to the changes,
            we will provide you additional prominent notice as appropriate under the
            circumstances and ask for your consent in accordance with applicable law.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyContent;
